import script from "./LabProgressCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabProgressCard.vue?vue&type=script&setup=true&lang=ts"

import "./LabProgressCard.vue?vue&type=style&index=0&id=bebaa88c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bebaa88c"]])

export default __exports__